import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface PaymentPreprocessorState {
  status: boolean | null;
  error: string | null;
  data: Record<string, unknown> | null;
}

export const LEADER_IFRAME_BRIDGE_KEY = 'leaderIframeBridge';

export const initialPreprocessorResultState: PaymentPreprocessorState = {
  status: null,
  error: null,
  data: null,
};

export const leaderIframeBridgeSlice = createSlice({
  name: LEADER_IFRAME_BRIDGE_KEY,
  initialState: initialPreprocessorResultState,
  reducers: {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    requestSdkProcessor: () => {},
    continueProcessing: (
      state,
      action: PayloadAction<Record<string, any>>,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
    ) => {},
  },
});

export const preprocessorReducer = leaderIframeBridgeSlice.reducer;

export const { requestSdkProcessor, continueProcessing } =
  leaderIframeBridgeSlice.actions;
